/*-----This File Is For Graphics----- */
import React from "react";
import styles from "./../Style/ourteam.module.css";
import image7 from "./../Assets/image7.png";
import group59 from "./../Assets/Group59.png";
const Graphics = () => {
    return (
        <div className={styles.graphicsdiv}>
            <svg width="300" height="400" viewBox="0 0 100 450" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.topright}>
                <path
                    d="M43.6886 234.723C20.2308 147.177 70.6035 57.6545 156.141 34.7348C241.679 11.815 330.064 64.1574 353.522 151.703C376.98 239.249 326.607 328.772 241.069 351.691C155.532 374.611 67.1465 322.269 43.6886 234.723Z"
                    stroke="#0078D4"
                    stroke-width="2"
                />
                <path
                    d="M52.2853 231.541C30.0406 148.522 77.8085 63.6316 158.92 41.8979C240.031 20.1641 323.845 69.7978 346.09 152.816C368.334 235.835 320.566 320.725 239.455 342.459C158.344 364.193 74.53 314.559 52.2853 231.541Z"
                    stroke="#0078D4"
                    stroke-width="2"
                />
                <path
                    d="M61.1014 229.179C40.3124 151.593 84.9546 72.2602 160.754 51.9497C236.554 31.6392 314.882 78.0223 335.671 155.608C356.46 233.193 311.818 312.526 236.018 332.837C160.218 353.147 81.8903 306.764 61.1014 229.179Z"
                    stroke="#0078D4"
                    stroke-width="2"
                />
                <path
                    d="M69.9161 226.817C50.4616 154.211 92.2385 79.9733 163.169 60.9674C234.1 41.9615 307.399 85.365 326.854 157.97C346.308 230.576 304.531 304.814 233.6 323.82C162.67 342.825 89.3707 299.422 69.9161 226.817Z"
                    stroke="#0078D4"
                    stroke-width="2"
                />
                <path
                    d="M78.7329 224.454C60.6128 156.829 99.5244 87.6859 165.586 69.9847C231.648 52.2834 299.918 92.7073 318.038 160.332C336.159 227.958 297.247 297.101 231.185 314.802C165.123 332.503 96.853 292.079 78.7329 224.454Z"
                    stroke="#0078D4"
                    stroke-width="2"
                />
                <path
                    d="M88.0211 220.648C71.1748 157.776 107.351 93.4964 168.766 77.0405C230.18 60.5845 293.65 98.1643 310.496 161.036C327.343 223.907 291.166 288.187 229.752 304.643C168.337 321.099 104.867 283.519 88.0211 220.648Z"
                    stroke="#0078D4"
                    stroke-width="2"
                />
                <path
                    d="M96.8362 218.285C80.9668 159.06 116.285 98.1312 175.731 82.2026C235.178 66.274 296.229 101.381 312.098 160.606C327.968 219.831 292.649 280.76 233.203 296.689C173.757 312.617 112.706 277.511 96.8362 218.285Z"
                    stroke="#0078D4"
                    stroke-width="2"
                />
                <path
                    d="M107.366 215.904C92.6444 160.963 124.612 104.687 178.73 90.1856C232.849 75.6847 288.672 108.437 303.393 163.378C318.114 218.319 286.147 274.595 232.028 289.096C177.91 303.597 122.087 270.844 107.366 215.904Z"
                    stroke="#0078D4"
                    stroke-width="2"
                />
                <path
                    d="M115.49 214.166C101.921 163.523 131.239 111.697 180.927 98.3834C230.616 85.0694 281.919 115.293 295.488 165.936C309.058 216.579 279.74 268.404 230.052 281.718C180.363 295.032 129.06 264.809 115.49 214.166Z"
                    stroke="#0078D4"
                    stroke-width="2"
                />
            </svg>

            <svg width="200" height="200" viewBox="0 0 337 298" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.bottomleft}>
                <path
                    d="M336 254C336 393.647 212.292 507 59.5 507C-93.2919 507 -217 393.647 -217 254C-217 114.354 -93.2919 1.00012 59.5 1.00012C212.292 1.00012 336 114.354 336 254Z"
                    stroke="#2A7FE2"
                    stroke-width="2"
                />
                <path
                    d="M320.306 255.306C320.306 387.74 202.986 495.247 58.0735 495.247C-86.8388 495.247 -204.159 387.74 -204.159 255.306C-204.159 122.872 -86.8388 15.3654 58.0735 15.3654C202.986 15.3654 320.306 122.872 320.306 255.306Z"
                    stroke="#2A7FE2"
                    stroke-width="2"
                />
                <path
                    d="M304.612 255.306C304.612 379.086 194.957 479.576 59.5005 479.576C-75.9562 479.576 -185.611 379.086 -185.611 255.306C-185.611 131.527 -75.9562 31.0362 59.5005 31.0362C194.957 31.0362 304.612 131.527 304.612 255.306Z"
                    stroke="#2A7FE2"
                    stroke-width="2"
                />
                <path
                    d="M288.918 255.306C288.918 371.152 186.289 465.211 59.4998 465.211C-67.2893 465.211 -169.918 371.152 -169.918 255.306C-169.918 139.46 -67.2893 45.4009 59.4998 45.4009C186.289 45.4009 288.918 139.46 288.918 255.306Z"
                    stroke="#2A7FE2"
                    stroke-width="2"
                />
                <path
                    d="M273.224 255.306C273.224 363.218 177.621 450.846 59.5 450.846C-58.6214 450.846 -154.224 363.218 -154.224 255.306C-154.224 147.394 -58.6214 59.7662 59.5 59.7662C177.621 59.7662 273.224 147.394 273.224 255.306Z"
                    stroke="#2A7FE2"
                    stroke-width="2"
                />
                <path
                    d="M256.103 257.265C256.103 357.604 167.208 439.093 57.3601 439.093C-52.4877 439.093 -141.383 357.604 -141.383 257.265C-141.383 156.926 -52.4877 75.4371 57.3601 75.4371C167.208 75.4371 256.103 156.926 256.103 257.265Z"
                    stroke="#2A7FE2"
                    stroke-width="2"
                />
                <path
                    d="M240.409 257.265C240.409 351.811 154.414 428.645 48.0863 428.645C-58.2414 428.645 -144.236 351.811 -144.236 257.265C-144.236 162.719 -58.2414 85.8843 48.0863 85.8843C154.414 85.8843 240.409 162.719 240.409 257.265Z"
                    stroke="#2A7FE2"
                    stroke-width="2"
                />
                <path
                    d="M221.861 256.612C221.861 344.322 143.513 415.586 46.6588 415.586C-50.1956 415.586 -128.543 344.322 -128.543 256.612C-128.543 168.901 -50.1956 97.6373 46.6588 97.6373C143.513 97.6373 221.861 168.901 221.861 256.612Z"
                    stroke="#2A7FE2"
                    stroke-width="2"
                />
                <path
                    d="M207.594 255.959C207.594 336.821 135.63 402.527 46.6591 402.527C-42.312 402.527 -114.275 336.821 -114.275 255.959C-114.275 175.097 -42.312 109.391 46.6591 109.391C135.63 109.391 207.594 175.097 207.594 255.959Z"
                    stroke="#2A7FE2"
                    stroke-width="2"
                />
            </svg>
            <div className={styles.image7}>
                <img src={image7} />
            </div>
            <div className={styles.image8}>
                <img src={image7} />
            </div>
            <div className={styles.group59}>
                <img src={group59} />
            </div>
        </div>
        /*-----div Ends here-----*/
    );
};

export default Graphics;
